/**
 * A refusal in the engine's own words (`error.message` of its answer), as opposed to one of Paige's
 * (`detail`, already written for a person) or the engine not answering at all. Callers that must not
 * show the engine's sentence to a customer recognise it by this type (confirm-save.ts).
 */
export class EngineRefusedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EngineRefusedError';
  }
}
